/* Passive touch highlighting; preserve scrolling and collection links. */
(() => {
  const initialize = (root) => {
    root.querySelectorAll('.crown-category-grid').forEach((grid) => {
      if (grid.dataset.crownLightReady) return;
      grid.dataset.crownLightReady = 'true';
      let activeCard = null;
      let frame = 0;
      let point = null;

      const clearCard = () => {
        if (!activeCard) return;
        activeCard.classList.remove('is-touch-lit');
        activeCard = null;
      };

      const paint = () => {
        frame = 0;
        if (!point || !grid.isConnected) return;
        const card = document.elementFromPoint(point.x, point.y)?.closest('.collection-card');
        if (!card || !grid.contains(card)) {
          clearCard();
          return;
        }
        if (activeCard !== card) clearCard();
        activeCard = card;
        card.classList.add('is-touch-lit');
      };

      const end = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        point = null;
        clearCard();
      };

      const follow = (event) => {
        if (event.touches.length !== 1) {
          end();
          return;
        }
        const touch = event.touches[0];
        point = { x: touch.clientX, y: touch.clientY };
        if (!frame) frame = requestAnimationFrame(paint);
      };

      grid.addEventListener('touchstart', follow, { passive: true });
      grid.addEventListener('touchmove', follow, { passive: true });
      grid.addEventListener('touchend', end, { passive: true });
      grid.addEventListener('touchcancel', end, { passive: true });
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
